<template>
  <main>
    <div class="index">
      <div id="content">
        <div id="carNumBox">
          <ul class="carNumType">
            <li
              class="squaredThree headLable headLable-lp headLable-check"
              value="1"
            >
              蓝牌
            </li>
            <li class="squaredThree headLable headLable-xny">新能源</li>
            <li class="squaredThree headLable headLable-hp" value="2">黄牌</li>
          </ul>
          <div class="carLicenseMain">
            <ul>
              <li class="main"></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li></li>
              <li class="xinnengyuan" style="display: none"></li>
            </ul>
          </div>
          <div style="text-align: center">
            <input
              type="button"
              class="aaa disabled"
              value="立即查询"
              id="submitBtn"
              @click="submitBtn()"
              disabled="true"
            />
            <p class="wxts">
              温馨提醒：缴费成功后，请尽快离场，否则可能重新计费！
            </p>
          </div>
          <div id="keyboardBox">
            <div id="carPlateBox">
              <ul class="carPlateUL">
                <li class="carPlateLI" v-for="(car,index) in carNums"
                v-bind:key="index" :class="liColor[car.carCategory]" @click="setCarPlate(car)"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)">
                {{ car.carNo }}
                </li>
                <li class="carPlateLI" @click="managerCar()" @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)">管理车辆</li>
              </ul>
            </div>
            <div class="provinceBox" id="provinceBox">
              <ul>
                <li
                  v-for="txt in provinceLine1"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
              </ul>
              <ul>
                <li
                  v-for="txt in provinceLine2"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
              </ul>
              <ul>
                <li
                  v-for="txt in provinceLine3"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
              </ul>
              <ul>
                <li
                  class="changeContentBtn other"
                  style="font-size: 0.2rem"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  关闭
                </li>
                <li
                  v-for="txt in provinceLine4"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
                <li
                  class="deleteBtn other"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  <img src="../assets/img/deleteImg.png" />
                </li>
              </ul>
            </div>
            <div class="textBox" id="textBox">
              <ul>
                <li
                  v-for="txt in txtLine1"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
              </ul>
              <ul>
                <li
                  v-for="txt in txtLine2"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
              </ul>
              <ul>
                <li
                  v-for="txt in txtLine3"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
              </ul>
              <ul>
                <li
                  class="changeContentBtn other"
                  style="font-size: 0.2rem"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  关闭
                </li>
                <li
                  v-for="txt in txtLine4"
                  v-bind:key="txt"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  {{ txt }}
                </li>
                <li
                  class="deleteBtn other"
                  @touchstart="touchStart($event)"
                  @touchend="touchEnd($event)"
                  @touchcancel="touchEnd($event)"
                  @mousedown="touchStart($event)"
                  @mouseup="touchEnd($event)"
                >
                  <img src="../assets/img/deleteImg.png" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <ul class="carOwenerServerBox">
            <li
              class="carServer carReservation"
              @click="carReservationClick($event)"
            >
              车位预约
            </li>
            <li
              class="carServer discountActivity"
              @click="discountActivityClick($event)"
            >
              优惠活动
            </li>
            <li
              class="carServer thirdPartyService"
              @click="thirdPartyServiceClick($event)"
            >
              第三方服务
            </li>
          </ul>
        </div>
        <div class="information">
          <p class="bannerTitle">资讯</p>
          <div class="e">
            <ul
              v-for="item in parksInfo"
              :key="item.index"
              @click="selectItem(item.id)"
            >
              <li>
                <p class="left">{{ item.title }}</p>
                <h3 class="right">{{item.updateTime}}</h3>
                <img src="../assets/3.png" alt="" class="photo">
              </li>

            </ul>
          </div>
        </div>
        <div class="banner">

          <div class="bannerTitle">停车场列表</div>
          <ul
            v-for="(item, index) in parks"
            :key="index"
            @click="link(item.id)"
            :class="{
              active: index % 4 == 0,
              active1: index % 4 == 1,
              active2: index % 4 == 2,
              active3: index % 4 == 3,
            }"
          >
            <li class="parkName">{{ item.name }}</li>
            <li class="parkAddr">地址:&emsp;{{ item.location }}</li>
            <li class="carPositionNum">总车位:&emsp;{{ item.lotCount }}</li>
            <li class="idleCarPositionNum">
              剩余车位:&emsp;{{ item.lotFree }}
            </li>
          </ul>
        </div>
        <div>
          <van-overlay :show="show" z-index="100">
            <div class="wrapper" @click.stop>
              <div class="block">
                <van-loading type="spinner" color="#1989fa" size="50" />
                <van-progress
                  :show-pivot="false"
                  color="green"
                  :percentage="50"
                  stroke-width="8"
                />
                <p>正在查询...</p>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
    <tabbar current="1"></tabbar>
  </main>
</template>

<script>
import tabbar from "../components/Tabbar.vue";
import { idx } from "../assets/js/index.js";
import API from "../api/index";
import { Cookies } from "../util/index";
import { Toast } from "vant";
import { Dialog } from "vant";
import successVue from "./success.vue";

export default {
  name: "index",
  components: { tabbar },
  data() {
    return {
      txtLine1: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
      txtLine2: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K"],
      txtLine3: ["L", "M", "N", "P", "Q", "R", "S", "T", "U", "V"],
      txtLine4: ["W", "X", "Y", "Z", "学", "警", "港", "澳"],
      provinceLine1: ["京", "津", "黑", "吉", "辽", "冀", "豫", "鲁", "晋"],
      provinceLine2: ["陕", "蒙", "宁", "甘", "新", "青", "藏", "鄂", "皖"],
      provinceLine3: ["苏", "沪", "浙", "闽", "湘", "赣", "川", "渝", "贵"],
      provinceLine4: ["云", "粤", "桂", "琼", "使", "领"],
      parks: [],
      parksInfo: [],
      show: false,
      liColor:['blue','green','yellow'],
      carNums: [],
    };
  },
  mounted() {
    var _this = this;

    idx.init();

    this.$http({
      method: "get",
      data: {
      },
      url: API.loadParks_url,
    })
      .then(function (resp) {
        console.log(resp.data);
        _this.parks = resp.data.data;
      })
      .catch((resp) => {
        console.log("请求失败：" + resp.status + "," + resp.statusText);
      });

    this.$http({
      method: "get",
      data: {
      },
      url: API.loadParkInfo_url,
    })
      .then(function (resp) {
        console.log(resp.data);
        _this.parksInfo = resp.data.data;
      })
      .catch((resp) => {
        console.log("请求失败：" + resp.status + "," + resp.statusText);
      });
    this.$http({
      method:'get',
      params: {
        uId:Cookies.get("uId")
      },
      url:API.loadMyCar_url
          }).then(function(resp){
            if(resp.data.returnCode=="SUCCESS"){
              _this.carNums=resp.data.data;
            }
            }).catch(resp => {
              console.log('请求失败：'+resp.status+','+resp.statusText);
          });
  },

  computed: {},

  methods: {
    touchStart(event) {
      $(event.currentTarget).addClass("keyboardBox-select");
    },
    touchEnd(event) {
      $(event.currentTarget).removeClass("keyboardBox-select");
    },
    carReservationClick(event) {
      alert("建设中");
      console.log(event);
    },
    discountActivityClick(event) {
      alert("建设中");
      console.log(event);
    },
    thirdPartyServiceClick(event) {
      alert("建设中");
      console.log(event);
    },
    setCarPlate(car){
      idx.setCarNum(car);
    },
    managerCar(){
      if(Cookies.get('uId')){
        this.$router.push({ path: "/mycar"});
      } else {
        Toast("请先绑定手机号");
        var _this=this;
        setTimeout(function(){
          _this.$router.push({ path: "/phone"});
        },2000);
      }
    },

    link(id) {
      console.log("==" + id);
      this.$router.push({ path: "/carinfo/" + id });
    },

    selectItem(id) {
      console.log("==" + id);
      this.$router.push({ path: "/advice/" + id });
    },

    submitBtn() {
      var websocket = null;
      var _this = this;
      //判断当前浏览器是否支持WebSocket
      if ("WebSocket" in window) {
        websocket = new WebSocket(
          API.skt_cacl_url +
            "?carNum=" +
            idx.data().carNumStr +
            "&bizType=parking&parkId=" +
            Cookies.get("parkId") +
            "&userId=" +
            Cookies.get("userId") +
            "&userType=" +
            Cookies.get("userType") +
            ""
        );
        //连接发生错误的回调方法
        websocket.onerror = function () {
          // 提示连接错误
          Toast("连接错误");
        };

        //连接成功建立的回调方法
        websocket.onopen = function () {
          // 打开弹窗
          _this.show = true;
          heartCheck.reset().start();
        };

        //接收到消息的回调方法
        websocket.onmessage = function (event) {
          //心跳
          if ("PONG" == event.data) {
            heartCheck.reset().start();
            return;
          }
          var json = JSON.parse(event.data);
          if (json.returnCode != "SUCCESS") {
            Toast(json.returnMsg);
            _this.show = false;
            closeWebSocket();
            return;
          }

          _this.show = false;
          _this.$router.push({
            name: "pay",
            params: {
              carNum: idx.data().carNumStr,
              fee: json.data.fee,
              inTime: json.data.inTime,
              duration: json.data.duration,
              parkId: json.data.parkId,
              bizType: json.data.bizType,
              calcMsgId: json.data.calcMsgId,
            },
          });
        };

        //连接关闭的回调方法
        websocket.onclose = function (e) {
          // 提示信息
          console.log(
            new Date() +
              " websocket断开: code:" +
              e.code +
              " reason:" +
              e.reason +
              " wasClean:" +
              e.wasClean
          );
          _this.show = false;
          heartCheck.reset();
        };

        //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = function () {
          closeWebSocket();
        };
      } else {
        Toast("当前浏览器 Not support websocket");
      }
      //关闭WebSocket连接
      function closeWebSocket() {
        websocket.close();
        heartCheck.reset();
      }
      //心跳检测
      var heartCheck = {
        timeout: 50000, //单位 秒
        timeoutObj: null,
        serverTimeoutObj: null,
        reset: function () {
          clearTimeout(this.timeoutObj);
          clearTimeout(this.serverTimeoutObj);
          return this;
        },
        start: function () {
          var self = this;
          this.timeoutObj = setTimeout(function () {
            //这里发送一个心跳，后端收到后，返回一个心跳消息，
            //onmessage拿到返回的心跳就说明连接正常
            websocket.send("PING");
            self.serverTimeoutObj = setTimeout(function () {
              //如果超过一定时间还没重置，说明后端主动断开了
              websocket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
            }, self.timeout);
          }, this.timeout);
        },
      };
    },
  },
};
</script>

<style scoped>
.banner {
  background: #ffffff;
}
.bannerTitle {
  padding: 17px 15px;
  font-size: 30px;
  color: #343434;
  background: #fff;
  font-weight: bold;
  margin-bottom: 10px;

}

.e .left {
    float: left;
    width: 480px;
}

.e .right {
  float: left;

}

.e .photo {
  float: right;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}

.information {
  width: 710px;
  height: 310px;
  margin-top: 15px;
  margin-bottom: 35px;
  /* float: left; */
}

.e {
  overflow: scroll;
  height: 250px;
}

.e ul {
  margin: 5px;
  padding-left: 50px;
  padding: 20px;
  float: left;
  background: #fff;
  border-bottom-style: solid;
  border-width: 3px;
  border-color: #999999;
  width: 100%;
}

/* .parkShow {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
} */

.banner ul {
  width: 345px;
  height: 161px;
  background: #fff;
  float: left;
  margin: 5px;
  margin-top: 15px;
  padding: 5px;
  border-radius: 10px;
  font-size: 20px;
}
.parkBanner .parkName {
  font-size: 26px;
}
.parkBanner .parkAddr {
  font-size: 26px;
}
.parkBanner .carPositionNum {
  font-size: 26px;
}
.parkBanner .idleCarPositionNum {
  font-size: 26px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 490px;
  height: 390px;
  background-color: #fff;
}

/* .block img {
    margin: 60px 80px;
} */

/deep/.van-loading__spinner {
  margin: 100px 200px;
}

.block p {
  margin-top: 20px;
  text-align: center;
  font-size: 30px;
}

/deep/.van-progress {
  width: 370px;
  /* height: 20px; */
  margin-left: 50px;
}
.banner .active {
  background: #C9D3FF;
}
.banner .active1 {
  background: #C9FFCA;
}
.banner .active2 {
  background: #C9FDFF;
}
.banner .active3 {
  background: #E0C9FF;
}
#carPlateBox{
  width: 750px;
	overflow-x: auto;
}
.carPlateUL{
  width: auto;
  overflow-x: auto;
  white-space:nowrap;
}
.carPlateLI{
  display: inline-block;
  height: 80px;
  line-height: 80px;
  margin: 0px 12px;
  font-family:"PingFang SC";
  font-weight: bold;
  font-size: 30px;
  color: white;
  text-align: center;
  background:#37c192;
  border-radius: 5px;
  padding: 0 20px;
}
.carPlateLI.blue{
  background: #498CE7;
}
.carPlateLI.green{
  background: #15B65D;
}
.carPlateLI.yellow{
  background: #FFCC00;
  color:#333333;
}
.carPlateLI.keyboardBox-select{
  background-color: #1faf96;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue